/**
 * 组件使用场景：查看车辆详情
 * API使用 ->
 * API:import { showCarDetail } from '@/shared/utils';
 * showCarDetail(id，renderFooterFn?) //主键id =>required
 * */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from '@souche-f2e/muji';
import store, { dispatch } from '@@/store';
import DetialModal from './components';
/**
 * API
 * */
let componentRef = '';
const createAbortiveAuction = (footerFn) => {
    let div = document.getElementsByClassName('souche-car-detail')[0];
    if (!div) {
        div = document.createElement('div');
        div.className = 'souche-car-detail';
        document.body.appendChild(div);
    }
    const refFn = (ref) => {
        componentRef = ref;
    };
    const Create = React.createElement;
    const component = (<Provider store={store}>
      {Create(DetialModal, {
        footerRender: footerFn,
        ref: refFn,
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function showCarDetail(id, footerFn) {
    if (!componentRef) {
        createAbortiveAuction();
    }
    if (footerFn) {
        createAbortiveAuction(footerFn);
    }
    dispatch.carDetail.SET_STATE({
        showFooter: !!footerFn,
    });
    dispatch.carDetail.show(true);
    dispatch.carDetail.queryDetail(id);
}
